import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import FleetSection from "../components/FleetSection";
import ExperiencesSection from "../components/ExperiencesSection";
import ContactCTA from "../components/ContactCTA";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <Marquee />
      <Manifesto />
      <FleetSection />
      <ExperiencesSection />
      <ContactCTA />
    </div>
  );
}
